module.exports = __webpack_public_path__ + "media/packs/images/flags/PH-184e0f03e22f8731aaadf8dde9d6827b.png";